import { toast } from "react-toastify";
import { CALL_DETAILS, CALL_EXECUTIVE, CALL_MANAGER, COMMON } from "../config/apiEndPoint";
import { DEL, GET, MULTIPART_POST, POST, PUT } from "config/api.config";

export const fetchCallExecutiveMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveScheduledFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_SCHEDULED_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchCallExecutiveInterviewMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_INTERVIEW_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveInterviewFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_INTERVIEW_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchCallExecutiveNotOnAiMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_NOT_ON_AI_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveNotOnAiFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_NOT_ON_AI_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchCallExecutiveTodayMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_TODAY);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveTodayFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_TODAY_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `CallExecutive/today/quick-update` — body `{ candidateClientId, value }`. */
export const submitCallExecutiveQuickUpdate = async (
  candidateClientId = "",
  value = ""
) => {
  const id = String(candidateClientId ?? "").trim();
  if (!id) {
    toast.error("Candidate client id is missing");
    return null;
  }
  try {
    const response = await POST(CALL_EXECUTIVE.UPDATE_CALL_QUICK_UPDATE, {
      candidateClientId: id,
      value: String(value ?? ""),
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};

export const fetchCallExecutiveWrongNumberMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_WRONG_NUMBER_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveWrongNumberFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_WRONG_NUMBER_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchCallExecutiveInProgressMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_IN_PROGRESS_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveInProgressFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_IN_PROGRESS_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/manager/oip/metadata` — Call Manager Order In Progress table + filter schema. */
export const fetchCallManagerOrderInProgressMetadata = async () => {
  try {
    const response = await GET(CALL_MANAGER.GET_OIP_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/manager/oip/filter` — Call Manager Order In Progress paged list. */
export const submitCallManagerOrderInProgressFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_MANAGER.SUBMIT_OIP_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/manager/{id}/mark-eligible` — mark an Order In Progress candidate eligible. */
export const submitCallManagerOrderInProgressMarkEligible = async (id = "") => {
  const recordId = String(id ?? "").trim();
  if (!recordId) {
    toast.error("Record id is missing");
    return null;
  }
  try {
    const response = await POST(CALL_MANAGER.OIP_MARK_ELIGIBLE(recordId), {});
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};

/** GET `call/manager/oe/metadata` — Call Manager Order Eligible (Ready To Send) table + filter schema. */
export const fetchCallManagerOrderEligibleMetadata = async () => {
  try {
    const response = await GET(CALL_MANAGER.GET_OE_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/manager/oe/filter` — Call Manager Order Eligible (Ready To Send) paged list. */
export const submitCallManagerOrderEligibleFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_MANAGER.SUBMIT_OE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/manager/fr/metadata` — Call Manager Further Review table + filter schema. */
export const fetchCallManagerFurtherReviewMetadata = async () => {
  try {
    const response = await GET(CALL_MANAGER.GET_FR_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/manager/fr/filter` — Call Manager Further Review paged list. */
export const submitCallManagerFurtherReviewFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_MANAGER.SUBMIT_FR_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/manager/{id}/resolved` — resolve a further-review candidate. Body `{ orderStatus, reasonsId }`. */
export const submitCallManagerFurtherReviewResolved = async (
  id = "",
  status = "",
  reasonsId = null
) => {
  const recordId = String(id ?? "").trim();
  if (!recordId) {
    toast.error("Record id is missing");
    return null;
  }
  try {
    const trimmedReasonsId = String(reasonsId ?? "").trim();
    const response = await POST(CALL_MANAGER.FR_RESOLVED(recordId), {
      orderStatus: String(status ?? "").trim(),
      reasonsId: trimmedReasonsId || null,
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};

export const fetchCallExecutiveUnderAgeMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_UNDER_AGE_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallExecutiveUnderAgeFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_UNDER_AGE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchMyCallMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_MY_CALL_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitMyCallFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_MY_CALL_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchDeactivateCandidateMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_DEACTIVE_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitDeactivateCandidateFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_DEACTIVE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/rtr-acknowledge/metadata` — RTR Acknowledgement table + filter schema. */
export const fetchRtrAcknowledgeMetadata = async () => {
  try {
    const response = await GET(CALL_EXECUTIVE.GET_RTR_ACKNOWLEDGE_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `all/rtr-acknowledge/filter` — RTR Acknowledgement paged list. */
export const submitRtrAcknowledgeFilterData = async (data = {}) => {
  try {
    const response = await POST(CALL_EXECUTIVE.SUBMIT_RTR_ACKNOWLEDGE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `call/rtr-acknowledge/{id}` — body `{ notes, acknowledgeType }` (`yes` / `no`). */
export const submitRtrAcknowledgeAction = async (id = "", data = {}) => {
  const recordId = String(id ?? "").trim();
  if (!recordId) {
    toast.error("Record id is missing");
    return null;
  }
  try {
    const response = await PUT(CALL_EXECUTIVE.RTR_ACKNOWLEDGE_SUBMIT(recordId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `call/rtr-acknowledge/{id}` — body `{ notes }` (notes column blur). */
export const submitRtrAcknowledgeNotes = async (id = "", data = {}) => {
  const recordId = String(id ?? "").trim();
  if (!recordId) {
    toast.error("Record id is missing");
    return null;
  }
  try {
    const response = await PUT(CALL_EXECUTIVE.RTR_ACKNOWLEDGE_SUBMIT(recordId), {
      notes: String(data?.notes ?? ""),
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};

/** DELETE `call/rtr-acknowledge/{id}` — remove an RTR acknowledgement record. */
export const deleteRtrAcknowledge = async (id = "") => {
  const recordId = String(id ?? "").trim();
  if (!recordId) {
    toast.error("Record id is missing");
    return null;
  }
  try {
    const response = await DEL(CALL_EXECUTIVE.RTR_ACKNOWLEDGE_SUBMIT(recordId));
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};

export const getFedexCandidateForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateId
      ? CALL_DETAILS.FEDEX_CANDIDATE_GET(data.candidateId)
      : CALL_DETAILS.FEDEX_CANDIDATE_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getCandidateTestsForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateId
      ? CALL_DETAILS.CANDIDATE_TESTS_GET(data.candidateId)
      : CALL_DETAILS.CANDIDATE_TESTS_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/details/{candidateClientId}/road-test` — road test schedule for Application Status modal. */
export const getRoadTestScheduleForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.ROAD_TEST_SCHEDULE_GET(data.candidateClientId)
      : CALL_DETAILS.ROAD_TEST_SCHEDULE_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const buildRoadTestScheduleFormData = (payload = {}) => {
  const fd = new FormData();
  const appendScalar = (key, value) => {
    if (value === null || value === undefined) {
      fd.append(key, "");
      return;
    }
    if (value instanceof File || value instanceof Blob) {
      fd.append(key, value);
      return;
    }
    fd.append(key, String(value));
  };

  appendScalar("candidateClientId", payload.candidateClientId);
  appendScalar("jobRequireId", payload.jobRequireId);
  appendScalar("candidateTestId", payload.candidateTestId ?? "");
  appendScalar("rawStatus", payload.rawStatus);
  appendScalar(
    "testDate",
    payload.testDate == null || payload.testDate === "" ? "" : payload.testDate
  );
  appendScalar("testDateTimeMinutes", Number(payload?.testDateTimeMinutes) || 0);
  appendScalar("location", payload.location);
  appendScalar("notes", payload.notes);

  if (payload.attachmentId) {
    appendScalar("attachmentId", payload.attachmentId);
  }
  if (payload.file instanceof File) {
    fd.append("attachment", payload.file);
  } else if (payload.attachment instanceof File) {
    fd.append("attachment", payload.attachment);
  }

  return fd;
};

/** POST `call/details/{candidateClientId}/road-test` — multipart FormData (Application Status road test modal). */
export const submitRoadTestScheduleForCallDetails = async (payload = {}) => {
  try {
    const candidateClientId = String(payload?.candidateClientId ?? "").trim();
    if (!candidateClientId) {
      toast.error("Candidate client id is required.");
      return undefined;
    }
    const url = CALL_DETAILS.ROAD_TEST_SCHEDULE_POST(candidateClientId);
    const formData =
      payload?.formData instanceof FormData
        ? payload.formData
        : buildRoadTestScheduleFormData(payload);
    const response = await MULTIPART_POST(url, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/fadv/{candidateClientId}` — Application Status FADV panel. */
export const getFadvPanelForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_PANEL_GET(data.candidateClientId)
      : CALL_DETAILS.FADV_PANEL_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `common/fadv-package` — body `{ primaryIds: string[] }` → `{ id, display }[]`. */
export const getFadvPackageOptionsForCallDetails = async (data = {}) => {
  try {
    const response = await POST(COMMON.FADV_PACKAGE, {
      primaryIds: Array.isArray(data?.primaryIds) ? data.primaryIds : [],
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/fadv/package/status/{candidateClientId}` — FADV package status reload. */
export const reloadFadvPackageStatusForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_PACKAGE_STATUS_POST(data.candidateClientId)
      : CALL_DETAILS.FADV_PACKAGE_STATUS_POST("");
    const response = await POST(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/fadv/package/send` — `{ candidateClientId, fadvApiId, email }`. */
export const sendFadvPackageForCallDetails = async (data = {}) => {
  try {
    const response = await POST(CALL_DETAILS.FADV_PACKAGE_SEND_POST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/fadv/{candidateClientId}/send-link` — body `{ value: string }`. */
export const sendFadvSendLinkForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_SEND_LINK_POST(data.candidateClientId)
      : CALL_DETAILS.FADV_SEND_LINK_POST("");
    const response = await POST(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/fadv/driver-profile/image/{candidateClientId}` — Application Status profile row. */
export const getFadvDriverProfileImageForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_DRIVER_PROFILE_IMAGE_GET(data.candidateClientId)
      : CALL_DETAILS.FADV_DRIVER_PROFILE_IMAGE_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/fadv/driver-profile/metadata/{candidateClientId}` — FEC driver profile metadata rows. */
export const getFadvDriverProfileMetadataForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_DRIVER_PROFILE_METADATA_GET(data.candidateClientId)
      : CALL_DETAILS.FADV_DRIVER_PROFILE_METADATA_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/fadv/profile-details/background-image/{candidateClientId}` — reload background image. */
export const reloadFadvProfileBackgroundImageForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_PROFILE_BACKGROUND_IMAGE_RELOAD_GET(data.candidateClientId)
      : CALL_DETAILS.FADV_PROFILE_BACKGROUND_IMAGE_RELOAD_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/fadv/profile-details/order-details/{candidateClientId}`. */
export const sendFadvProfileOrderDetailsForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_PROFILE_ORDER_DETAILS_POST(data.candidateClientId)
      : CALL_DETAILS.FADV_PROFILE_ORDER_DETAILS_POST("");
    const response = await POST(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/fadv/driver-profile/api/{candidateClientId}` — driver details send. */
export const sendFadvDriverProfileApiForCallDetails = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.FADV_DRIVER_PROFILE_API_POST(data.candidateClientId)
      : CALL_DETAILS.FADV_DRIVER_PROFILE_API_POST("");
    const response = await POST(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const candidateTestRequestBodyToFormData = (body) => {
    const fd = new FormData();
    if (!body || typeof body !== "object") return fd;
    for (const [key, value] of Object.entries(body)) {
        if (value === null || value === undefined) {
            fd.append(key, "");
        } else if (typeof value === "object" && !(value instanceof Blob) && !(value instanceof File)) {
            fd.append(key, JSON.stringify(value));
        } else {
            fd.append(key, value);
        }
    }
    return fd;
};

const isCallDetailsMailRouteKey = (routeKey) => {
    const normalizedRouteKey = String(routeKey ?? "").trim();
    return (
        /^(call|candidate)\/mail\//i.test(normalizedRouteKey) ||
        /\/mail-scrap\//i.test(normalizedRouteKey)
    );
};

export const invokeCallDetailsPageActionPost = async (data = {}) => {
  try {
    const id = String(data?.candidateId ?? "").trim();
    const routeKey = String(data?.routeKey ?? "").trim();
    if (!routeKey) return undefined;
    const url = CALL_DETAILS.CANDIDATE_TEST_ACTION_REQUEST(
      id,
      routeKey,
      data?.routeArgument
    );
    const requestBody =
      data?.requestBody && typeof data.requestBody === "object"
        ? data.requestBody
        : {};
    const response = await POST(url, requestBody);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const invokeCandidateTestActionForCallDetails = async (data = {}) => {
  try {
    const id = String(data?.candidateId ?? "").trim();
    const routeKey = String(data?.routeKey ?? "").trim();
    if (!routeKey) return undefined;
    const url = CALL_DETAILS.CANDIDATE_TEST_ACTION_REQUEST(
      id,
      routeKey,
      data?.routeArgument
    );
    const httpMethod = String(data?.httpMethod ?? "POST").trim().toUpperCase();

    if (httpMethod === "GET") {
      const response = await GET(url);
      return response;
    }

    const rawBody =
      data?.requestBody && typeof data.requestBody === "object"
        ? data.requestBody
        : {};

    if (isCallDetailsMailRouteKey(routeKey)) {
      return await invokeCallDetailsPageActionPost({
        candidateId: id,
        routeKey,
        routeArgument: data?.routeArgument,
        requestBody: rawBody,
      });
    }

    const formData =
      data?.formData instanceof FormData
        ? data.formData
        : candidateTestRequestBodyToFormData(rawBody);
    const response = await MULTIPART_POST(url, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const invokeCandidateTestActionMultipartFormForCallDetails = async (data = {}) => {
  try {
    const id = String(data?.candidateId ?? "").trim();
    const routeKey = String(data?.routeKey ?? "").trim();
    if (!routeKey) return undefined;
    const formData = data?.formData;
    if (!(formData instanceof FormData)) return undefined;
    const url = CALL_DETAILS.CANDIDATE_TEST_ACTION_REQUEST(
      id,
      routeKey,
      data?.routeArgument
    );
    const response = await MULTIPART_POST(url, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFedexExistingDriverForCallDetails = async (data = {}) => {
  try {
    const response = await POST(CALL_DETAILS.FEDEX_EXISTING_DRIVER_POST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const uncheckExistingFedexDriverForCallDetails = async (data = {}) => {
  const candidateClientId = String(data?.candidateClientId ?? "").trim();
  try {
    const response = await POST(CALL_DETAILS.UNCHECK_EXISTING_FEDEX(candidateClientId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateCallDetailsEmail = async (data = {}) => {
  try {
    const url = data?.callDetailsId
      ? CALL_DETAILS.EMAIL(data.callDetailsId)
      : CALL_DETAILS.EMAIL("");
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateCallDetailsFedexId = async (data = {}) => {
  try {
    const url = data?.callDetailsId
      ? CALL_DETAILS.FEDEX_ID(data.callDetailsId)
      : CALL_DETAILS.FEDEX_ID("");
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallDetailsCallStatus = async (data = {}) => {
  try {
    const response = await POST(CALL_DETAILS.CALL_STATUS_POST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/details/transcript/{aiCallTranscriptId}` — full AI call transcript for Call Details modal. */
export const getCallDetailsAiTranscript = async (data = {}) => {
  try {
    const transcriptId = String(data?.aiCallTranscriptId ?? data?.transcriptId ?? "").trim();
    if (!transcriptId) return null;
    const response = await GET(CALL_DETAILS.CALL_TRANSCRIPT_GET(transcriptId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const resolveCallDetailsConversationId = (data = {}) =>
  String(data?.callDetailsId ?? data?.candidateClientId ?? data?.candidateId ?? "").trim();

/** GET `call/details/{callDetailsId}/conversation` — conversation messages for Call Details modal. */
export const getCallDetailsConversation = async (data = {}) => {
  try {
    const callDetailsId = resolveCallDetailsConversationId(data);
    if (!callDetailsId) return null;
    const response = await GET(CALL_DETAILS.CONVERSATION_GET(callDetailsId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/details/{callDetailsId}/conversation/render-template` — render SMS template HTML. */
export const renderCallDetailsConversationTemplate = async (data = {}) => {
  try {
    const callDetailsId = resolveCallDetailsConversationId(data);
    const templateId = String(data?.templateId ?? "").trim();
    if (!callDetailsId) {
      toast.error("Call details ID is required to render template.");
      return null;
    }
    if (!templateId) {
      toast.error("Please select a template.");
      return null;
    }
    const response = await POST(
      CALL_DETAILS.CONVERSATION_RENDER_TEMPLATE_POST(callDetailsId),
      { templateId }
    );
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/details/{callDetailsId}/conversation` — send conversation message. */
export const sendCallDetailsConversationMessage = async (data = {}) => {
  try {
    const callDetailsId = resolveCallDetailsConversationId(data);
    const message = String(data?.message ?? "").trim();
    if (!callDetailsId) {
      toast.error("Call details ID is required to send message.");
      return null;
    }
    if (!message) {
      toast.error("Message is required.");
      return null;
    }
    const response = await POST(CALL_DETAILS.CONVERSATION_POST(callDetailsId), { message });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const extractCallDetailsRenderedTemplateHtml = (apiResponse) => {
  const payload = apiResponse?.data ?? apiResponse;
  if (typeof payload === "string") return payload.trim();
  if (!payload || typeof payload !== "object") return "";
  const nested = payload?.data;
  if (typeof nested === "string") return nested.trim();
  if (nested && typeof nested === "object") {
    return String(
      nested?.html ?? nested?.message ?? nested?.content ?? nested?.body ?? ""
    ).trim();
  }
  return String(
    payload?.html ?? payload?.message ?? payload?.content ?? payload?.body ?? ""
  ).trim();
};

/** GET `call/details/{callDetailsId}/ai-call-scheduled` — AI call schedule rows for Call Details modal. */
export const getCallDetailsAiCallScheduled = async (data = {}) => {
  try {
    const callDetailsId = String(
      data?.callDetailsId ?? data?.candidateClientId ?? data?.candidateId ?? ""
    ).trim();
    if (!callDetailsId) return null;
    const response = await GET(CALL_DETAILS.AI_CALL_SCHEDULED_GET(callDetailsId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getCallDetailsPreScreening = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.PRE_SCREENING_GET(data.candidateClientId)
      : CALL_DETAILS.PRE_SCREENING_GET("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallDetailsPreScreening = async (data = {}) => {
  try {
    const response = await POST(CALL_DETAILS.PRE_SCREENING_POST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const pickFirstNonEmptyAttachmentUrl = (...candidates) => {
  for (const c of candidates) {
    const s = String(c ?? "").trim();
    if (s && s.toLowerCase() !== "null") return s;
  }
  return "";
};

export const resolveCommonAttachmentDownloadUrl = (apiResponse) => {
  const data = apiResponse?.data;
  if (data == null) return "";
  if (typeof data === "string") {
    const s = data.trim();
    return s || "";
  }
  if (typeof data !== "object") return "";
  const node = data?.data != null && typeof data.data === "object" ? data.data : data;
  const absolute = pickFirstNonEmptyAttachmentUrl(
    node.downloadUrl,
    typeof node.data === "string" ? node.data : node.data?.url
  );
  if (absolute && /^https?:\/\//i.test(absolute)) return absolute;
  const relative = pickFirstNonEmptyAttachmentUrl(node.path, node.relativePath, node.filePath);
  if (relative && /^https?:\/\//i.test(relative)) return relative;
  if (relative) {
    const base = String(process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");
    if (base) {
      return relative.startsWith("/") ? `${base}${relative}` : `${base}/${relative}`;
    }
    return relative;
  }
  return "";
};

export const getCommonAttachmentById = async (data = {}) => {
  try {
    const url = data?.attachmentId
      ? COMMON.ATTACHMENT_BY_ID(data.attachmentId)
      : data?.id
        ? COMMON.ATTACHMENT_BY_ID(data.id)
        : COMMON.ATTACHMENT_BY_ID("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getCallDetailsUpperToolbar = async (data = {}) => {
  try {
    const url = data?.candidateClientId
      ? CALL_DETAILS.CALL_DETAILS_GET_TOOLBAR(data.candidateClientId)
      : CALL_DETAILS.CALL_DETAILS_GET_TOOLBAR("");
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/details/{callDetailsId}/interview-video-link` — load video interview link. */
export const getInterviewVideoLinkForCallDetails = async (data = {}) => {
  try {
    const callDetailsId = String(data?.id ?? data?.callDetailsId ?? "").trim();
    if (!callDetailsId) return null;
    const response = await GET(CALL_DETAILS.INTERVIEW_VIDEO_LINK_GET(callDetailsId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `call/details/interview-video-link` — save video interview link for a candidate. */
export const submitInterviewVideoLink = async (data = {}) => {
  try {
    const response = await POST(CALL_DETAILS.INTERVIEW_VIDEO_LINK_POST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `call/details/{callDetailsId}/client-info` — Client Info tab for Call Details. */
export const getCallDetailsClientInfo = async (data = {}) => {
  try {
    const callDetailsId = String(
      data?.callDetailsId ?? data?.candidateId ?? data?.id ?? ""
    ).trim();
    if (!callDetailsId) return null;
    const response = await GET(CALL_DETAILS.CLIENT_INFO_GET(callDetailsId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
